module.exports = __webpack_public_path__ + "img/icon_kalinba_logo.c66c3ce7.png";